// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import App from './App'
import router from './router'
import {
    store
} from './store/store'

import './bibliotecas/appPrototypes'
import './bibliotecas/appFiltros'
import './bibliotecas/textoHelpers'
import './components/registroComponentes'
import './bibliotecas/vue/vuetoastr'
import './bibliotecas/vue/vuejwt'
import './bibliotecas/vue/vuemomentlib'
import './bibliotecas/vue/vuesweetalert2'
import './bibliotecas/vue/vuemask'
import './bibliotecas/vue/vuevcalendar'
import './bibliotecas/vue/vuedatepicker'
import './bibliotecas/vue/vuecurrencyfilter'
import './bibliotecas/vue/vueanalitics'
import './bibliotecas/vue/vuelodash'
import './bibliotecas/vue/vueawesomecountdown'
// import './bibliotecas/vue/axiosConfig'

Vue.use(BootstrapVue)
Vue.use(Vuelidate)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
})



// WEBPACK FOOTER //
// ./src/main.js